declare const Stripe;
import * as _ from "lodash";
import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { HouseOccupantService } from "../../services/house-occupant.service";
import { HouseService } from "../../services/house.service";
import { Campaign } from "../../models/campaign.model";
import { PermissionCheck } from "../../shared/permission";
import { CredentialsManager } from "../../shared/credentials-manager";
import { UserDataProvider } from "../../data-provider/user.dp";
import { ToastUtils } from "../../helper/toast.helper";
import { DialogUtils } from "../../helper/dialog.helper";
import { LimitDataProvider } from "../../data-provider/limit.dp";
import { SubscriptionDataProvider } from "../../data-provider/subscription.dp";
import { FieldDataProvider } from "../../data-provider/field.dp";
import { Field } from "../../models/field.model";
import { Limit } from "../../models/limit.model";
import { Plan } from "../../models/plan.model";
import { User } from "../../models/user.model";

let UpgradePlanFormComponent = {
    selector: "vcUpgradePlanForm",
    templateUrl:
        "/angular/components/campaign-plan/upgrade-plan-form.component.html",
    bindings: {
        type: "=",
        conversionType: "=",
        charge: "=",
        planCallback: "&?",
        registerCallback: "&?",
        options: "=?",
        reloadOnSuccess: "=?",
    },
    controller: class UpgradePlanFormController {
        // * bindings for typescript compiler *
        public type: any;
        public conversionType: any;
        public charge: any;
        public planCallback?: Function;
        public registerCallback?: Function;
        public options?: any;
        public reloadOnSuccess?: any;
        // ************************************

        private __env: any;
        private $window: any;
        private $scope: any;
        private dialog: DialogUtils;
        private $http: any;
        private toast: ToastUtils;
        private stripe: any;

        private limitDataProvider: LimitDataProvider;
        private subscriptionDataProvider: SubscriptionDataProvider;
        private houseService: HouseService;
        private houseOccupantService: HouseOccupantService;
        private userDataProvider: UserDataProvider;
        private campaignDataProvider: CampaignDataProvider;
        private credentialsManager: CredentialsManager;
        private fieldDataProvider: FieldDataProvider;
        private customFields: Field[];
        private $timeout: any;

        public readonly notRecommendedPlans = [
            "Essentials",
            "Legacy",
            "Starter",
            "Standard",
            "Standard Plus",
        ];
        public readonly planColors = {
            Legacy: "#e6dbdb",
            Starter: "#eabcbf",
            Standard: "#69d8bd",
            StandardPlus: "#ffb37f",
            Pro: "#578aca",
        };

        public permissionProvider: PermissionCheck;
        public recommendedPlan;
        public selectedInterval: any;
        public stage: string;
        public peopleCount: number;
        public usersCount: any;
        public create_error: string;
        public activeLegacyPlan: any = null;
        public accountLimits: Limit;
        public campaign: Campaign;
        public activeCampaign: Campaign;
        public campaignname: string;
        public toggle: any;
        public loading: boolean = true;
        public cardLoading: boolean = false;
        public newCard: boolean = true;
        public card: any;
        public promotion: any;
        public plans: any = [];
        public plan: any = null;
        public selected_plan: any = null;
        public user: User;

        public selectedCoreLevel: number = 0;
        public selectedProLevel: number = 0;

        constructor(
            CampaignDataProvider: CampaignDataProvider,
            HouseOccupantService: HouseOccupantService,
            PermissionCheck: PermissionCheck,
            UserDataProvider: UserDataProvider,
            FieldDataProvider: FieldDataProvider,
            DialogUtils: DialogUtils,
            $window: any,
            $scope: any,
            $timeout: any,
            __env: any,
            $http: any,
            CredentialsManager: CredentialsManager,
            LimitDataProvider: LimitDataProvider,
            SubscriptionDataProvider: SubscriptionDataProvider,
            HouseService: HouseService,
            ToastUtils: ToastUtils
        ) {
            this.__env = __env;
            this.$window = $window;
            this.$scope = $scope;
            this.dialog = DialogUtils;
            this.$http = $http;
            this.toast = ToastUtils;
            this.stripe = Stripe(this.__env.stripe_api_key);

            this.permissionProvider = PermissionCheck;
            this.limitDataProvider = LimitDataProvider;
            this.fieldDataProvider = FieldDataProvider;
            this.subscriptionDataProvider = SubscriptionDataProvider;
            this.houseService = HouseService;
            this.houseOccupantService = HouseOccupantService;
            this.userDataProvider = UserDataProvider;
            this.campaignDataProvider = CampaignDataProvider;
            this.credentialsManager = CredentialsManager;
            this.$timeout = $timeout;
            this.user = UserDataProvider.getActiveUser();

            this.campaign = this.campaignDataProvider.getActiveCampaign();
            this.selectedInterval = this.campaign.cpinterval;
            this.toggle = {
                flex: this.__env.product_name == "Ecanvasser" ? 70 : 35,
                gt_md: this.__env.product_name == "Ecanvasser" ? 40 : 20,
                yearly: this.__env.product_name == "Ecanvasser",
            };
            this.promotion = {};

            this.subscriptionDataProvider
                .planInfo(this.campaign.cpid)
                .then((activePlan) => {
                    if (activePlan.cpname === "Legacy") {
                        this.activeLegacyPlan = activePlan;
                        this.activeLegacyPlan.color =
                            this.planColors[
                                this.activeLegacyPlan.cpname.replace(/\s+/g, "")
                            ];
                    }
                });

            this.fieldDataProvider.getAllFields().then(() => {
                this.customFields = this.fieldDataProvider.customFields;
                this.customFields = this.customFields.filter((field: Field) => {
                    return !field.orgid;
                });
            });

            this.limitDataProvider.get().then((accountLimits: Limit) => {
                this.accountLimits = accountLimits;
            });
        }

        $onInit() {
            if (
                this.conversionType == "deleted" ||
                this.conversionType == "create"
            ) {
                this.stage = "campaignname";
            } else {
                this.stage = "plan";
            }

            if (angular.isUndefined(this.reloadOnSuccess)) {
                this.reloadOnSuccess = true;
            }

            if (this.options) {
                _.merge(this.options, {
                    resetPlan: () => {
                        this.plan = null;
                    },
                });
            }

            if (this.campaign.paymentFailed()) {
                this.getCard();
            }

            this.subscriptionDataProvider
                .getPlans(this.campaign.campaignid, null)
                .then((plans) => {
                    let coreMonthlyPlans: any[] = [];
                    let coreYearlyPlans: any[] = [];
                    let proMonthlyPlans: any[] = [];
                    let proYearlyPlans: any[] = [];
                    angular.forEach(plans, (plan) => {
                        if (plan.cpname.startsWith("Core")) {
                            if (plan.cpinterval == "Monthly") {
                                coreMonthlyPlans.push(plan);
                            } else {
                                coreYearlyPlans.push(plan);
                            }
                        } else if (plan.cpname.startsWith("Pro")) {
                            if (plan.cpinterval == "Monthly") {
                                proMonthlyPlans.push(plan);
                            } else {
                                proYearlyPlans.push(plan);
                            }
                        }
                    });

                    this.plans = {
                        core: {
                            monthly: { plans: coreMonthlyPlans },
                            yearly: { plans: coreYearlyPlans },
                        },
                        pro: {
                            monthly: { plans: proMonthlyPlans },
                            yearly: { plans: proYearlyPlans },
                        },
                    };

                    this.loading = false;

                    this.peopleCount = 0;
                    if (
                        this.conversionType != "deleted" &&
                        this.conversionType != "signup"
                    ) {
                        this.houseOccupantService
                            .count()
                            .then((response: object) => {
                                const json = response["data"];
                                if (json.success) {
                                    this.peopleCount = parseInt(json.data);
                                }
                                this.houseService
                                    .count()
                                    .then((response: object) => {
                                        const json = response["data"];
                                        if (json.success) {
                                            this.peopleCount = parseInt(
                                                json.data
                                            );
                                        }

                                        this.recommendedPlan =
                                            this.getRecommendedPlan();

                                        this.userDataProvider
                                            .getUsersCount()
                                            .then((count) => {
                                                this.usersCount = count;

                                                angular.forEach(
                                                    this.plans.core.monthly
                                                        .plans,
                                                    (
                                                        plan: any,
                                                        index: number
                                                    ) => {
                                                        if (
                                                            plan.cpid ==
                                                            this.campaign.cpid
                                                        ) {
                                                            this.selectedCoreLevel =
                                                                index;
                                                        }

                                                        plan.color =
                                                            this.planColors[
                                                                plan.cpname.replace(
                                                                    /\s+/g,
                                                                    ""
                                                                )
                                                            ];
                                                        if (plan.cpid != "") {
                                                            plan.getExceededLimits(
                                                                this
                                                                    .customFields,
                                                                this
                                                                    .peopleCount,
                                                                this.usersCount,
                                                                this
                                                                    .accountLimits,
                                                                this.permissionProvider.hasPermission(
                                                                    "USERLIMIT"
                                                                )
                                                            );

                                                            if (
                                                                this
                                                                    .conversionType ==
                                                                    "incomplete" &&
                                                                this.campaign
                                                                    .cpid ==
                                                                    plan.cpid
                                                            ) {
                                                                this.setPlan(
                                                                    plan
                                                                );
                                                            }
                                                        }
                                                    }
                                                );

                                                angular.forEach(
                                                    this.plans.pro.monthly
                                                        .plans,
                                                    (
                                                        plan: any,
                                                        index: number
                                                    ) => {
                                                        if (
                                                            plan.cpid ==
                                                            this.campaign.cpid
                                                        ) {
                                                            this.selectedProLevel =
                                                                index;
                                                        }

                                                        plan.color =
                                                            this.planColors[
                                                                plan.cpname.replace(
                                                                    /\s+/g,
                                                                    ""
                                                                )
                                                            ];
                                                        if (plan.cpid != "") {
                                                            plan.getExceededLimits(
                                                                this
                                                                    .customFields,
                                                                this
                                                                    .peopleCount,
                                                                this.usersCount,
                                                                this
                                                                    .accountLimits,
                                                                this.permissionProvider.hasPermission(
                                                                    "USERLIMIT"
                                                                )
                                                            );

                                                            if (
                                                                this
                                                                    .conversionType ==
                                                                    "incomplete" &&
                                                                this.campaign
                                                                    .cpid ==
                                                                    plan.cpid
                                                            ) {
                                                                this.setPlan(
                                                                    plan
                                                                );
                                                            }
                                                        }
                                                    }
                                                );

                                                this.loading = false;
                                            });
                                    });
                            });
                    } else {
                        this.loading = false;
                        this.recommendedPlan = this.plans.filter((plan) => {
                            return plan.cpname == "Pro";
                        })[0];
                    }
                });
        }

        close(card, payment_method) {
            //Check if user is here due to having a deleted campaign, if so, create a new campaign, else, upgrade
            if (this.conversionType == "signup") {
                if (this.registerCallback) {
                    this.registerCallback({ payment_method: payment_method });
                }
                return;
            }

            this.cardLoading = true;
            if (
                this.campaign.campaignstatusid == 3 ||
                this.campaign.permissionid == 7 ||
                this.conversionType == "create"
            ) {
                this.createCampaign();
            } else {
                this.plan.conversiontype = this.conversionType;
                this.plan.promotion_code = this.promotion.id;
                this.submitUpgrade(this.plan);
            }
        }

        /**
         * Calls the upgrade endpoint. If the bank demands 3DS the backend
         * answers with requires_action + the invoice intent's client secret;
         * Stripe.js then runs the challenge in the browser and we re-submit
         * as an 'incomplete' conversion so the trial-end step is not repeated.
         */
        private submitUpgrade(payload: any): void {
            this.subscriptionDataProvider
                .upgrade(this.campaign.campaignid, payload)
                .then(
                    (campaign) => this.onUpgradeSuccess(campaign),
                    (error) => {
                        if (
                            error &&
                            error.requires_action &&
                            error.client_secret
                        ) {
                            this.authenticatePayment(error.client_secret);
                            return;
                        }

                        this.paymentFailed(error);
                    }
                );
        }

        /**
         * Single failure path for the upgrade and 3DS steps. ToastUtils
         * already extracts a string `message` from whatever it is given
         * (backend body or Stripe error); we only supply the fallback when
         * there is none. Runs through $timeout because Stripe's promises
         * resolve outside Angular's digest.
         */
        private paymentFailed(error?: any): void {
            this.$timeout(() => {
                this.cardLoading = false;
                const hasMessage =
                    error &&
                    typeof error.message === "string" &&
                    error.message.length > 0;
                this.toast.error(
                    hasMessage
                        ? error
                        : "We are unable to authenticate your payment method. Please choose a different payment method and try again."
                );
            });
        }

        private authenticatePayment(clientSecret: string): void {
            // The invoice's PaymentIntent already has the saved card attached,
            // so confirmCardPayment with just the client secret runs the 3DS
            // challenge and completes the payment.
            this.stripe
                .confirmCardPayment(clientSecret)
                .then((result) => {
                    if (result.error) {
                        this.paymentFailed(result.error);
                        return;
                    }

                    // The invoice is now paid; finalise the campaign state.
                    this.$timeout(() => {
                        const payload = _.merge({}, this.plan, {
                            conversiontype: "incomplete",
                        });
                        this.submitUpgrade(payload);
                    });
                })
                .catch((err) => {
                    console.error("Stripe confirmCardPayment failed", err);
                    this.paymentFailed(err);
                });
        }

        private onUpgradeSuccess(campaign: Campaign): void {
            this.campaignDataProvider.setActiveCampaign(campaign);
            this.campaign.cpid = campaign.cpid;
            this.toast.success("Account subscription upgraded");
            this.$timeout(() => {
                if (this.type == "dialog") {
                    this.dialog.hide();
                } else {
                    this.$window.location = "/#/ ";
                }

                if (this.reloadOnSuccess) {
                    this.$window.location.reload();
                } else {
                    this.limitDataProvider.getLimits();
                }
            }, 1000);
        }

        shouldShowCTA(plan: Plan): boolean {
            return !(
                (this.conversionType == "change" ||
                    this.conversionType == "endTrial") &&
                plan &&
                plan.exceededLimits &&
                plan.exceededLimits.length
            );
        }

        getClassPlan(campaignplan: any): string {
            if (this.recommendedPlan) {
                if (
                    this.planMatchesAnyLevel(campaignplan) &&
                    this.conversionType != "create"
                ) {
                    if (!this.selected_plan) {
                        if (campaignplan.plans[0].cpid == this.campaign.cpid) {
                            this.selected_plan = campaignplan.plans[0];
                        } else if (
                            campaignplan.plans[1].cpid == this.campaign.cpid
                        ) {
                            this.selected_plan = campaignplan.plans[1];
                        } else if (
                            campaignplan.plans[2].cpid == this.campaign.cpid
                        ) {
                            this.selected_plan = campaignplan.plans[2];
                        }
                    }
                    return "current-plan current-plan-style";
                } else if (campaignplan == this.recommendedPlan) {
                    return "rec-plan";
                }
            }
            return "";
        }

        createCampaign() {
            this.create_error = "";
            const data = {
                campaignname: this.campaignname,
                plan: this.plan,
                promotion_code: this.promotion.id,
            };
            this.cardLoading = true;
            this.$http.post("/v2/campaign/create", data).then(
                (response) => {
                    const json = response["data"];

                    if (json.success) {
                        if (!this.__env.test) {
                            if (this.conversionType == "create") {
                                this.$window.ga("send", {
                                    hitType: "event",
                                    eventCategory: "signup",
                                    eventAction: "completed",
                                    eventLabel:
                                        "create campaign for existing customer",
                                    eventValue: 1,
                                });
                            } else if (this.conversionType == "deleted") {
                                this.$window.ga("send", {
                                    hitType: "event",
                                    eventCategory: "signup",
                                    eventAction: "completed",
                                    eventLabel:
                                        "create campaign for deleted customer",
                                    eventValue: 1,
                                });
                            }
                        }
                        this.activeCampaign =
                            this.campaignDataProvider.setActiveCampaign(
                                json.campaign
                            );
                        this.activeCampaign.localInfo = {};
                        this.credentialsManager.redirect(
                            "create",
                            json.campaign.campaignid
                        );
                    } else {
                        if (json.error) {
                            if (json.error.jsonBody.error.message) {
                                this.create_error =
                                    json.error.jsonBody.error.message;
                            } else {
                                this.toast.error(
                                    "Create " +
                                        this.__env.strings.campaign +
                                        " failed, An error has occured, contact " +
                                        this.__env.support_email
                                );
                            }
                        } else {
                            this.toast.error(
                                "Create " +
                                    this.__env.strings.campaign +
                                    " failed, An error has occured, contact " +
                                    this.__env.support_email
                            );
                        }
                    }
                },
                () => {
                    this.toast.error(
                        "Create " +
                            this.__env.strings.campaign +
                            " failed, An error has occured, contact " +
                            this.__env.support_email
                    );
                }
            );
        }

        getRecommendedPlan(): any {
            return this.plans.pro;
        }

        openIntercomChat(): void {
            this.$window.Intercom(
                "showNewMessage",
                "Hi, I would like to change to Ecanvasser Essentials please"
            );
        }

        setPlan(plan): void {
            plan.loading = true;
            this.plan = plan;
            if (this.charge == false) {
                if (this.conversionType == "signup") {
                    this.subscriptionDataProvider
                        .setupIntentSignup()
                        .then((intent) => {
                            if (this.planCallback) {
                                this.planCallback({ plan: this.plan });
                            }
                            this.plan.loading = false;
                            this.plan.intent = intent;
                        });
                } else {
                    this.cardLoading = true;
                    this.subscriptionDataProvider
                        .setupIntentUpgrade()
                        .then((intent) => {
                            this.plan.loading = false;
                            this.plan.intent = intent;
                            this.getCard();
                        });
                }
            } else {
                this.subscriptionDataProvider
                    .paymentIntent(plan.cpid)
                    .then((intent) => {
                        this.plan.loading = false;
                        this.plan.intent = intent;
                    });
            }
        }

        getCard(): void {
            this.cardLoading = true;
            this.subscriptionDataProvider.card().then((card) => {
                this.newCard = !card;
                this.card = card;
                this.cardLoading = false;
            });
        }

        toggleCardDialog(newValue): void {
            this.newCard = newValue;
        }

        openCreditCardModal($event: any): void {
            this.newCard = true;
            this.subscriptionDataProvider.setupIntent().then((intent: any) => {
                let parentEl = angular.element(document.body);
                this.dialog
                    .show({
                        parent: parentEl,
                        component: "vc-create-credit-card-modal",
                        targetEvent: $event,
                        scope: this.$scope,
                        locals: {
                            user: this.user,
                            plan: { intent: intent },
                            charge: false,
                        },
                        ariaLabel: "Update Card",
                    })
                    .then(() => {
                        this.subscriptionDataProvider.card().then((card) => {
                            this.card = card;
                            this.newCard = false;
                        });
                    });
            });
        }

        cancel(): void {
            this.dialog.hide();
        }

        planMatchesAnyLevel(campaignplan: any): boolean {
            return (
                campaignplan.plans[0].cpid == this.campaign.cpid ||
                campaignplan.plans[1].cpid == this.campaign.cpid ||
                campaignplan.plans[2].cpid == this.campaign.cpid
            );
        }
    },
};

angular
    .module("campaignplan")
    .component(UpgradePlanFormComponent.selector, UpgradePlanFormComponent);
